// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-dropdown {
  position: relative;
  display: inline-block;
}

/* Style for the language button */
.language-button {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #163B6B;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 130px;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* Style for the flag icons */
.flag-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

/* Style for the language options */
.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 10px;
  border: 0.2px solid #163B6B;
  border-radius: 4px;
  z-index: 1;
  width: 130px;
}

/* Style for each language option */
.language-option {
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* Hover effect for language options */
.language-option:hover {
  background-color: #f2f2f2;
}

@media only screen and (min-width: 0px) and (max-width: 768px) {
  .language-button {
    padding: 5px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/LanguageOption/LanguageOption.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEE,kCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACE,8BAAA;AACN;;AAEE,6BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEE,mCAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAEE,mCAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACE,8BAAA;AACN;;AAEE,sCAAA;AACA;EACE,yBAAA;AACJ;;AAEE;EACE;IACI,iBAAA;EACN;AACF","sourcesContent":[".language-dropdown {\r\n    position: relative;\r\n    display: inline-block;\r\n  }\r\n  \r\n  /* Style for the language button */\r\n  .language-button {\r\n    padding: 10px;\r\n    background-color: #fff;\r\n    border: 1px solid #163B6B;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 130px;\r\n    flex-direction: row-reverse;\r\n      justify-content: space-between;\r\n  }\r\n  \r\n  /* Style for the flag icons */\r\n  .flag-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  /* Style for the language options */\r\n  .language-options {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    border: 0.2px solid #163B6B;\r\n    border-radius: 4px;\r\n    z-index: 1;\r\n    width: 130px;  \r\n  }\r\n  \r\n  /* Style for each language option */\r\n  .language-option {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row-reverse;\r\n      justify-content: space-between;\r\n  }\r\n  \r\n  /* Hover effect for language options */\r\n  .language-option:hover {\r\n    background-color: #f2f2f2;\r\n  }\r\n\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) {\r\n    .language-button{\r\n        padding: 5px 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
